import s from "./highrise1675.mjs";
var i = Array.prototype, l = i.splice;
function n(r) {
  var e = this.__data__, a = s(e, r);
  if (a < 0)
    return !1;
  var t = e.length - 1;
  return a == t ? e.pop() : l.call(e, a, 1), --this.size, !0;
}
export {
  n as default
};
